var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-component',{attrs:{"show_filter_modal":"","emit_on_saved_instead_continue":"","model_name":"employee"},on:{"modelSaved":_vm.modelSaved}})
}
var staticRenderFns = []

export { render, staticRenderFns }